import PageLayout from 'pages/StudentViewAssignment/PageLayout';
import PageProvider from 'pages/StudentViewAssignment/PageProvider';

const StudentViewAssignmentPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default StudentViewAssignmentPage;
